import api from "@/lib/api";

const SESSION_KEY = "pm_session_id";
const UTM_KEY = "pm_utm_source";
const CONSENT_KEY = "pm_cookie_consent";

const getSessionId = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `sess-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

const hasStatsConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    return JSON.parse(raw).stats === true;
  } catch {
    return false;
  }
};

// Capture le paramètre utm_source de l'URL une fois par session.
const getUtmSource = () => {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get("utm_source");
  if (fromUrl) {
    sessionStorage.setItem(UTM_KEY, fromUrl);
    return fromUrl;
  }
  return sessionStorage.getItem(UTM_KEY) || "";
};

export const trackEvent = (type, extra = {}) => {
  if (!hasStatsConsent()) return;
  api
    .post("/track", {
      type,
      session_id: getSessionId(),
      utm_source: getUtmSource(),
      ...extra,
    })
    .catch(() => {});
};

export const trackPageview = (path) => {
  trackEvent("pageview", {
    path,
    referrer: document.referrer && !document.referrer.includes(window.location.host)
      ? document.referrer
      : "",
  });
};

// Délégation globale : clics WhatsApp et Réserver.
export const initClickTracking = () => {
  document.addEventListener("click", (e) => {
    const wa = e.target.closest('a[href*="wa.me"]');
    if (wa) {
      trackEvent("click", { event: "whatsapp", path: window.location.pathname });
      return;
    }
    const resa = e.target.closest(
      'a[href="/reservation"], [data-testid="header-reserve-button"], [data-testid="hero-reserve-button"], [data-testid="contact-reserve-button"]'
    );
    if (resa) {
      trackEvent("click", { event: "reserver", path: window.location.pathname });
    }
  });
};
